import { Dispatch } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router';
import { Action } from 'redux';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';

import chevronIcon from '../../../assets/img/chevron-right.svg';
import bankIcon from '../../../assets/img/icon-bank.svg';
import cryptoIcon from '../../../assets/img/icon-crypto.svg';
import { useBrowserWidth, useIsMobile } from '../../../hooks';
import { UI_ROUTES } from '../../../util/routes';
import { ClickableDiv } from '../..';
import ContainerBackButton from '../../ContainerBackButton/ContainerBackButton';
import GoBackButton from '../../GoBackButton/GoBackButton';
import LogoAndCloseButton from '../../LogoAndCloseButton/LogoAndCloseButton';

import styles from './PayoutsChoosePayment.module.scss';

const PayoutsChoosePayment = ({
  hasBankAccount,
  linkedAccounts,
  cryptoLinkedAccounts,
}: ReduxProps) => {
  const navigate = useNavigate();
  const { browserWidthSize } = useBrowserWidth();
  const { isMobile } = useIsMobile();
  const goBackHandler = () => navigate(UI_ROUTES.payouts);
  const isDefaultGoBackButton = browserWidthSize >= 989 && !isMobile;

  const bankRedirect = () => {
    // Redirect to withdrawal if there are any bank accounts (including pending)
    if (linkedAccounts?.length > 0) {
      navigate(UI_ROUTES.payouts + UI_ROUTES.withdrawalAmount);
      return;
    }
    // Only redirect to add bank account if there are no accounts at all
    navigate(UI_ROUTES.payouts + UI_ROUTES.addYourBankAccount);
  };

  const cryptoRedirect = () => {
    if (cryptoLinkedAccounts?.length > 0) {
      navigate(UI_ROUTES.payouts + UI_ROUTES.withdrawCryptoAmount);
      return;
    }
    navigate(UI_ROUTES.payouts + UI_ROUTES.addCryptoAddress);
  };
  return (
    <>
      <div className={styles.container}>
        <LogoAndCloseButton
          displayCloseButton={false}
          displayBackButton={isDefaultGoBackButton}
          onBackBtnPress={goBackHandler}
          newWebGoBackButtonDesign
        />
        {!isDefaultGoBackButton && !isMobile && (
          <div className={styles.goBackButtonContainer}>
            <ContainerBackButton onBackBtnPress={goBackHandler} />
          </div>
        )}
        {isMobile && (
          <div className={styles.mobileBackContainer}>
            <GoBackButton onBackBtnPress={goBackHandler} />
          </div>
        )}
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <div className={styles.textWrapper}>
              <div className={styles.title}>{lang.payoutsSelectMethod()}</div>
              <div className={styles.text}>{lang.payoutsSelectMethodDesc()}</div>
            </div>
            <div className={styles.methodsWrapper}>
              <ClickableDiv className={styles.methodWrapper} onClick={() => bankRedirect()}>
                <div className={styles.methodContent}>
                  <div className={styles.iconWrapper}>
                    <img src={bankIcon} alt="bank" />
                  </div>
                  <div className={styles.methodTextWrapper}>
                    <div className={styles.methodTitle}>{lang.payoutsBankTransfer()}</div>
                    <div className={styles.methodText}>{lang.payoutsUpToBusinessDays(5)}</div>
                  </div>
                </div>
                <img className={styles.chevronIcon} src={chevronIcon} alt=">" />
              </ClickableDiv>
              <ClickableDiv className={styles.methodWrapper} onClick={() => cryptoRedirect()}>
                <div className={styles.methodContent}>
                  <div className={styles.iconWrapper}>
                    <img src={cryptoIcon} alt="crypto" />
                  </div>
                  <div className={styles.methodTextWrapper}>
                    <div className={styles.methodTitle}>{lang.payoutsCrypto()}</div>
                    <div className={styles.methodText}>
                      {lang.payoutsUsdtSolata()}
                      {lang.payoutsUpToBusinessDays(2)}
                    </div>
                  </div>
                </div>
                <img className={styles.chevronIcon} src={chevronIcon} alt=">" />
              </ClickableDiv>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  linkedAccounts: state.payment.linkedAccounts,
  cryptoLinkedAccounts: state.payment.cryptoLinkedAccounts,
  hasBankAccount: state.payment.hasBankAccount,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PayoutsChoosePayment);
